#import "../fragments/audience-basic.graphql"

query GetAudiencesBasic($excludeWebFXAudiences: Boolean) {
    audiences(sort: NAME_ASC, excludeWebFXAudiences: $excludeWebFXAudiences) {
        edges {
            node {
                ...AudienceBasic
            }
        }
    }
}
